import React from 'react'

const CircleGreenSvg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 13 13'
    >
      <circle
        id='Ellipse_221'
        data-name='Ellipse 221'
        cx='6.5'
        cy='6.5'
        r='6.5'
        fill='#30cb69'
      />
    </svg>
  )
}

export default CircleGreenSvg
